import api from './api';
import { toast } from 'react-toastify'
import { toUpperCase } from '../utils/objects'

export function findAllByFarmacia(farmaciaId, page, itemsPerPage) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/ativos`, {
        headers: { authorization: `Bearer ${token}` },
        params: { page, itemsPerPage }
      });

      return resolve(response.data);
    } catch (e) {
      return reject(e);
    }
  })
}

export function findById(farmaciaId, ativoId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/ativos/${ativoId}`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error('Erro ao buscar ativo');
      return reject(e);
    }
  });
}

export function save(farmaciaId, ativo) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.post(`farmacias/${farmaciaId}/ativos`, toUpperCase(ativo), {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao salvar ativo");
      return reject(e);
    }
  })
}

export function update(farmaciaId, ativoId, ativo, usuarioId = null) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.put(`farmacias/${farmaciaId}/ativos/${ativoId}`, toUpperCase(ativo), {
        headers: { authorization: `Bearer ${token}` },
        params: { usuarioId }
      });

      return resolve();
    } catch (e) {
      return reject(e);
    }
  })
}

export function remove(farmaciaId, ativo) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`farmacias/${farmaciaId}/ativos/${ativo.atv_in_codigo}`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error('Erro ao remover ativo');
      return reject(e);
    }
  })
}
